interface ChatLinkClick {
  /** クリックされた要素。DOM 要素以外（null 等）も受け、closest() の有無で判定する。 */
  target: unknown;
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}

interface ClosestCapable {
  closest: (
    selector: string,
  ) => { getAttribute: (name: string) => string | null } | null;
}

const canSearchAncestors = (target: unknown): target is ClosestCapable =>
  typeof (target as ClosestCapable | null)?.closest === "function";

/**
 * チャット本文のクリックが、同じタブで画面遷移する内部リンク（「詳細を開く」等）か。
 * 外部リンクや、修飾キー・中クリックで別タブに開く場合は背面の画面が変わらないので対象外。
 */
export const isInPageChatLinkClick = (event: ChatLinkClick): boolean => {
  if (event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return false;
  }
  if (!canSearchAncestors(event.target)) return false;
  const href = event.target.closest("a[href]")?.getAttribute("href");
  return (
    typeof href === "string" && href.startsWith("/") && !href.startsWith("//")
  );
};
